export const READ_PERSON_REQUEST = 'people/READ_PERSON_REQUEST';
export const READ_PERSON_SUCCESS = 'people/READ_PERSON_SUCCESS';
export const READ_PERSON_FAILURE = 'people/READ_PERSON_FAILURE';

export const READ_PEOPLE_REQUEST = 'people/READ_PEOPLE_REQUEST';
export const READ_PEOPLE_SUCCESS = 'people/READ_PEOPLE_SUCCESS';
export const READ_PEOPLE_FAILURE = 'people/READ_PEOPLE_FAILURE';

export const POPULATE_PEOPLE_MODAL = 'people/POPULATE_MODAL';


// WEBPACK FOOTER //
// ./src/modules/people/people.actionTypes.js